import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PositionState {
  positions: { id: number; name: string }[];
  dateRange: { start: string; end: string };
  selectedDate: string;
}

const getInitialSelectedDate = (): string => {
  return localStorage.getItem("selectedDate") || "";
};

const initialState: PositionState = {
  positions: [],
  dateRange: { start: "", end: "" },
  selectedDate: getInitialSelectedDate(),
};

const positionSlice = createSlice({
  name: "position",
  initialState,
  reducers: {
    setPositions(state, action: PayloadAction<{ id: number; name: string }[]>) {
      state.positions = action.payload;
    },
    setDateRange(state, action: PayloadAction<{ start: string; end: string }>) {
      state.dateRange = action.payload;
    },
    setSelectedDate(state, action: PayloadAction<string>) {
      state.selectedDate = action.payload;
      if (action.payload) {
        localStorage.setItem("selectedDate", action.payload);
      } else {
        localStorage.removeItem("selectedDate");
      }
    },
  },
});

export const { setPositions, setDateRange, setSelectedDate } = positionSlice.actions;
export default positionSlice.reducer;